import type { AppState } from "store/types";

/** @deprecated once new home page is GA */
export const getApplicationList = (state: AppState) =>
  state.homepage.applications;

export const getIsFetchingApplications = (state: AppState) =>
  state.homepage.isFetchingApplications;
